import React from 'react';
import { FiltersContextValue } from './types';

export const FiltersContext = React.createContext<FiltersContextValue | null>(null);

export function useFiltersContext(): FiltersContextValue {
    const context = React.useContext(FiltersContext);
    if (!context) {
        throw new Error('useListFilterContext must be used within a List');
    }
    return context;
}

export const ListFiltersContextProvider = ({ context, children }: { context: FiltersContextValue; children: React.ReactNode }) => {
    return <FiltersContext.Provider value={context}>{children}</FiltersContext.Provider>;
};
